import React from "react";

const Hero = () => {
  return (
    <section className="py-5 bg-gradient-primary text-white">
      <div className="container-fluid custom-container">
        <div className="row align-items-center">
          <div className="col-lg-7 mb-5 mb-lg-0 text-center text-lg-left">
            <h1 className="display-4 font-weight-bold mb-4">
              Formax Pay App – Earn up to 4% Cashback on Recharges & Bills!
            </h1>
            <p className="lead mb-4">
              Download the official Formax Pay APK to recharge, pay bills,
              become a PAN agent, sell insurance, and earn commissions – all
              from one app.
            </p>

            <div className="warning-box p-4 mb-4 rounded bg-white text-dark">
              <p className="mb-0 font-weight-semibold">
                Trusted by 1M+ retailers across India – safe, secure, and 100%
                Indian fintech app.
              </p>
            </div>

            <div className="d-flex flex-column flex-sm-row">
              <a
                href="#download"
                className="btn btn-light btn-lg px-4 py-3 mr-sm-3 mb-3 animate__animated animate__pulse animate__infinite"
              >
                <i className="fas fa-download mr-2"></i>Download APK
              </a>
              <a
                href="#screenshots"
                className="btn btn-outline-light btn-lg px-4 py-3 mb-3"
              >
                <i className="fas fa-images mr-2"></i>View Screenshots
              </a>
            </div>
          </div>
          <div className="col-lg-5 text-center">
            <img
              src="/assets/images/formaxpay-app.gif"
              alt="Formax Pay App Preview"
              className="img-fluid"
              style={{
                maxWidth: "700px",
                width: "100%",
                height: "auto",
                objectFit: "contain",
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
